function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    quntyselector();
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    document.querySelectorAll('.cart-text').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-nav');
        if(document.querySelector('.megamenu.open-mega')) document.querySelector('.megamenu.open-mega').classList.remove('open-mega');
        if(document.querySelector('.mega-list.active')) document.querySelector('.mega-list.active').classList.remove('active');
        if(document.querySelector('.white-page .section-header.dark-header')) document.querySelector('.white-page .section-header.dark-header').classList.remove('dark-header');
        if(document.querySelector('.dark-page .section-header')) document.querySelector('.dark-page .section-header').classList.add('dark-header');
        if(document.querySelector('.section-header.dark-header-hover')) document.querySelector('.section-header.dark-header-hover').classList.remove('dark-header-hover');
        init();
      });
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        if(document.querySelector('.megamenu.open-mega')) document.querySelector('.megamenu.open-mega').classList.remove('open-mega');
        if(document.querySelector('.mega-list.active')) document.querySelector('.mega-list.active').classList.remove('active');
        if(document.querySelector('.white-page .section-header.dark-header')) document.querySelector('.white-page .section-header.dark-header').classList.remove('dark-header');
        if(document.querySelector('.dark-page .section-header')) document.querySelector('.dark-page .section-header').classList.add('dark-header');
        if(document.querySelector('.section-header.dark-header-hover')) document.querySelector('.section-header.dark-header-hover').classList.remove('dark-header-hover');
        document.querySelector('body').classList.remove('open-menu','open-nav','open-search','open-sort','open-filter');
        init();
      });
    });
    
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });
const code = document.querySelector('body').getAttribute('data-countrycode');
          const upsellDivs = document.querySelectorAll('.main-upsell');
        let isMatchFound = false;

 
          if(upsellDivs){
          upsellDivs.forEach(div => {
          const countryCode = div.getAttribute('data-val');
          if(countryCode){
            if (countryCode.includes(code)) {
              div.style.display = 'flex'; // Show the matching upsell
               var i = 0
              , items = div.querySelectorAll(".pro-title")
              , itemsHeight = [];
            for (i = 0; i < items.length; i++)
                itemsHeight.push(items[i].offsetHeight);
            var maxHeight = Math.max(...itemsHeight);
            for (i = 0; i < items.length; i++)
                items[i].style.height = maxHeight + "px"
              isMatchFound = true;
            } else {
              div.style.display = 'none'; // Hide non-matching upsells
            }
          }
          else{
            div.style.display = 'none';
          }
          });
          // If no match found, show the first upsell
          if (!isMatchFound) {
          upsellDivs[0].style.display = 'flex';
          }
          }
   init()
    function init(){
      var i = 0;
      var items = document.querySelectorAll(".singal-upsell .pro-title");
      var itemsHeight = [];
      for (i = 0; i < items.length; i++) {
        itemsHeight.push(items[i].offsetHeight);
      }
      var maxHeight = Math.max(...itemsHeight);
      for (i = 0; i < items.length; i++) {
        items[i].style.height = maxHeight + "px";
      }
    }
    updateCartCount();
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    updateCartCount();
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartCount(){
  const url = '/cart.js';
  fetch(url)
  .then((resp) => resp.json())
  .then(function(data) {
    var cart_count = data.item_count;
    if(cart_count>0){
      document.querySelectorAll('.cart-count').forEach(function(count){
        count.innerHTML = cart_count;
      })
    }else{
      document.querySelectorAll('.cart-count').forEach(function(count){
        count.innerHTML = '';
      })
    }
  })
  .catch(function(error) {
    console.log(error);
  });
}

quntyselector();
function quntyselector(){
    document.querySelectorAll('.item_plus').forEach(function(plusbutton){
      plusbutton.addEventListener('click',function(e){
    
      var mainpara = plusbutton.closest('.main_qty');
      var centerQtyInput = mainpara.querySelector('.cart_qty');
      centerQtyInput.value = parseInt(centerQtyInput.value) + 1;
      
      var newLine = mainpara.querySelector('.item_plus').getAttribute('data-line-item');
      var newQty = mainpara.querySelector('input.cart_qty').value;
      addItem(newLine, newQty);
    })
    });

   document.querySelectorAll('.item_minus').forEach(function(minusbutton){
      minusbutton.addEventListener('click',function(e){
    
      var mainpara = minusbutton.closest('.main_qty');
      var centerQtyInput = mainpara.querySelector('.cart_qty');
      centerQtyInput.value = parseInt(centerQtyInput.value) - 1;
      
      var newLine = mainpara.querySelector('.item_minus').getAttribute('data-line-item');
      var newQty = mainpara.querySelector('input.cart_qty').value;
      addItem(newLine, newQty);
    })
    });

    document.querySelectorAll('.upsell-var').forEach(function(varUl){
      const scrollDrawer = document.querySelector('.drawer-middle')
      const varDiv = varUl.parentNode;
      varDiv.addEventListener('click',function(event){
         varUl.classList.toggle('show');
          scrollDrawer.scrollTop = scrollDrawer.scrollHeight;
      });      
    });
  
  document.querySelectorAll('.upsell-var li').forEach(function(varLi){
    const varUl = varLi.parentNode;


      varLi.addEventListener('click',function(event){
         var line = event.target.getAttribute('data-id');
         addItemNew(line);
         varUl.classList.remove('show');
        
      });
  });

    // if (event.target.classList.contains('var') && event.target.closest('.upsell-var')) {
    //   var line = event.target.getAttribute('data-id');
    //   addItemNew(line);
    // }
  
}
  
  function addItem(newLine, newQty) {
    const data = { 'line': newLine, 'quantity': newQty };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  function addItemNew(line) {
    let data = {
     'items': [{
      'id': line,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
// })
// $(document).ready(function() {
//   $(document).on('click','.bottom-upsell .select-box',function(e){
//     $(this).next('.upsell-var').slideToggle()
//     $(this).toggleClass('active');
//     if($('.select-box.active').length == 2){
//       $('.singal-upsell').eq(1).find('ul.upsell-var').css('border-left','1px dashed transparent')
//     }
//     else{
//       $('.singal-upsell').eq(1).find('ul.upsell-var').css('border-left','1px dashed #959595')
//     }
//     // $(this).parents('.singal-upsell').siblings().find('.upsell-var').slideUp();
//     $('.drawer-middle').animate({scrollTop: $('.drawer-middle')[0].scrollHeight}, "slow");
//   });
// })